import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const SiteContext = createContext(null);

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState({});
  const [events, setEvents] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [specialDates, setSpecialDates] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [closures, setClosures] = useState([]);

  const refresh = useCallback(async () => {
    try {
      const [s, e, g, sd, r, c] = await Promise.all([
        api.get("/settings"),
        api.get("/events"),
        api.get("/gallery"),
        api.get("/special-dates"),
        api.get("/reviews"),
        api.get("/closures"),
      ]);
      setSettings(s.data || {});
      setEvents(e.data || []);
      setGallery(g.data || []);
      setSpecialDates(sd.data || []);
      setReviews(r.data || []);
      setClosures(c.data || []);
    } catch (err) {
      console.error("site load", err);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <SiteContext.Provider value={{ settings, events, gallery, specialDates, reviews, closures, refresh }}>
      {children}
    </SiteContext.Provider>
  );
}

export const useSite = () => useContext(SiteContext);
